// Import all images here and export them as constants
// This makes it easier to manage and update image paths across the application

// Import hero images
import heroImage1 from '../assets/images/home/hero-transform-01.png';
import heroImage2 from '../assets/images/home/hero-transform-02.png';
import heroImage3 from '../assets/images/home/hero-transform-03.png';
import heroImage4 from '../assets/images/home/hero-transform-04.png';
import heroImage5 from '../assets/images/home/hero-transform-05.png';

// Import AI assistant images
import aiAssistant1 from '../assets/images/home/ai_assistant_01.png';
import aiAssistant3 from '../assets/images/home/ai_assistant_03.png';
import aiAssistant5 from '../assets/images/home/ai_assistant_05.png';

// Import about images
import aboutBook1 from '../assets/images/about/book01.png';
import aboutBook2 from '../assets/images/about/book02.png';
import aboutBook3 from '../assets/images/about/book03.png';

// Export all images
export const AI_ASSISTANT_IMAGES = {
  AI_ASSISTANT_1: aiAssistant1,
  AI_ASSISTANT_3: aiAssistant3,
  AI_ASSISTANT_5: aiAssistant5
};

export const ABOUT_IMAGES = {
  BOOK_1: aboutBook1,
  BOOK_2: aboutBook2,
  BOOK_3: aboutBook3
};

// Home Hero Images
export const HERO_IMAGES = [
  heroImage1,
  heroImage2,
  heroImage3,
  heroImage4,
  heroImage5
];
